import ChangesLoyaltyProgramServiceTemplate
  from "../../templates/ChangesLoyaltyProgramServiceTemplate/ChangesLoyaltyProgramServiceTemplate";

const ChangesLoyaltyProgramServicePage = () => {
  return <ChangesLoyaltyProgramServiceTemplate />;
};

export default ChangesLoyaltyProgramServicePage;
